@if (label) {
  <app-control-header [label]="label" [index]="index" [required]="required"></app-control-header>
}
<div class="wrapper" [class.is-disabled]="isDisabled$ | async" [class.file-changed]="value" (blur)="markAsDirty()">
  @for (checkbox of checkboxes; track $index) {
    <app-checkbox
      class="checkbox-item"
      [attr.data-test-id]="checkbox.fieldName"
      [valueLabel]="checkbox.valueLabel"
      [icon]="checkbox.icon"
      [ngModel]="value && value[checkbox.fieldName]"
      (changeManually)="groupValueChange($event, checkbox)"
    ></app-checkbox>
  }
</div>
